export const SET_BULK_TAGS = 'SET_BULK_TAGS';
export const SET_BULK_TAGS_URL='SET_BULK_TAGS_URL';
export const SET_BULK_TAGS_REFERENCES = 'SET_BULK_TAGS_REFERENCES';